<template>
  <div class="flex flex-col gap-2">
    <label :for="id" class="font-medium block text-dark-600 dark:text-dark-400">{{ label }}
      <span v-if="required" class="text-red-500">*</span>
    </label>
    <div class="card flex justify-center">
      <Select v-if="isScrolled" :id="id" :name="name" v-model="displayValue" :options="options" :option-label="optionLabel"
        :option-value="optionValue" :placeholder="placeholder" :class="[!valid ? 'p-invalid' : '']" selectOnFocus="true"
        class="w-full md:w-56" :required="required"
        :virtualScrollerOptions="virtualScrollerOptions" fluid filter />
      <Select v-else :id="id" :name="name" v-model="displayValue" :options="options" :option-label="optionLabel"
        :option-value="optionValue" :placeholder="placeholder" :class="[!valid ? 'p-invalid' : '']" selectOnFocus="true"
        class="w-full md:w-56" :required="required" fluid filter />
    </div>
    <Message v-if="!valid" size="small" severity="error" variant="simple">{{ errorMessage }}
    </Message>
  </div>
</template>

<script>
import { Message, Select } from 'primevue';

export default {
  name: 'InputSelect',
  props: {
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    virtualScrollerOptions: {
      type: Object,
      default: null
    },
    isScrolled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Pilih opsi'
    },
    options: {
      type: Array,
      required: true
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
    valid: {
      type: Boolean,
      default: true
    },
    optionLabel: {
      type: String,
      default: 'label'
    },
    optionValue: {
      type: String,
      default: 'value'
    },
    errorMessage: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Select, Message
  },
  data() {
    return {
      displayValue: this.modelValue
    }
  },
  watch: {
    displayValue(newValue) {
      this.$emit('update:modelValue', newValue);
    },
    modelValue(newValue) {
      this.displayValue = newValue;
    }
  },
  emits: ['update:modelValue']
}
</script>